import { render, staticRenderFns } from "./thong-ke-phi-van-chuyen.vue?vue&type=template&id=b32dc528&"
import script from "./thong-ke-phi-van-chuyen.vue?vue&type=script&lang=js&"
export * from "./thong-ke-phi-van-chuyen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../DATA/projects/nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports